module.exports = __webpack_public_path__ + "img/960.c3a6ce2d.svg";